import React from 'react';
import styled from 'styled-components';
import { Group, GroupDirection, spacing } from '@landr/maestro';

const StyledGroup = styled(Group)`
    width: 100%;
    flex-wrap: nowrap;
    align-items: center;
    align-content: stretch;
    padding-top: ${spacing('jb')};
    padding-bottom: ${spacing('xxl')};

    ${({ theme }): string => theme.breakpoint('md')`
        padding-top: ${spacing('xxl')};
        padding-bottom: ${spacing('xl')};
    `}
`;

const SlideContentWrapper: React.FC<{ isVertical: boolean }> = ({
    isVertical,
    children,
}) => {
    const direction: GroupDirection = isVertical
        ? 'vertical-reverse'
        : 'horizontal';

    const gutter = isVertical ? 'xl' : 'mg';

    return (
        <StyledGroup gutter={gutter} direction={direction}>
            {children}
        </StyledGroup>
    );
};

export default SlideContentWrapper;
